/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectionModelProductMappingResponse } from '../../models/collection-model-product-mapping-response';

export interface GetProductMappings1$Params {
  merchantId?: string;
}

export function getProductMappings1(http: HttpClient, rootUrl: string, params?: GetProductMappings1$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionModelProductMappingResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductMappings1.PATH, 'get');
  if (params) {
    rb.query('merchantId', params.merchantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CollectionModelProductMappingResponse>;
    })
  );
}

getProductMappings1.PATH = '/product-mappings/all';
